/**
 * NotFoundPage Component
 *
 * 404 error page component for handling unknown routes.
 * Provides user-friendly messaging and navigation options.
 */

import React from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/Button';
import { useTheme } from '@/hooks/useTheme';
import { cn } from '@/utils/cn';
import { TitleText } from '../ui/TitleText';
import { Layout } from '../layout/Layout';

export interface NotFoundPageProps {
  className?: string;
  onGoHome?: () => void;
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({
  className,
  onGoHome
}) => {
  const navigate = useNavigate();
  const { isDark } = useTheme();

  const handleGoHome = () => {
    if (onGoHome) {
      onGoHome();
    } else {
      navigate('/');
    }
  };

  return (
    <Layout className={className}>
      <div className={cn("text-center py-12", className)}>
        <TitleText>
          404 - Page Not Found
        </TitleText>
        <p className={cn(
          "text-xl mb-8",
          isDark ? "text-secondary-300" : "text-secondary-600"
        )}>
          The page you're looking for doesn't exist.
        </p>
        <Button onClick={handleGoHome}>Go Home</Button>
      </div>
    </Layout>
  );
};

export default NotFoundPage;